const monthlyOperations = ['1', '2', '3', '4', '+ de 5'];
const monthlyAmount = [
  '$500 a $5,000',
  '$5,001 a $10,000',
  '$10,001 a $15,000',
  '$15,001 a $20,000',
  'Más de $20,000'
];
const resourcesOrigin = [
  'Sueldo Fijo',
  'Aguinaldo o Utilidades',
  'Ahorros',
  'Arrendamiento',
  'Becas',
  'Bonos e Incentivos',
  'Comisiones',
  'Dividendos',
  'Fideicomisos',
  'Fondos de Ahorro',
  'Herencia y/o Donación',
  'Honorarios',
  'Inversiones',
  'Negocio Propio',
  'Pensiones',
  'Préstamos Personales',
  'Rentas',
  'Rifas, Sorteos, Premios'
];
const resourcesDestination = [
  'Ahorro e Inversión',
  'Consumo',
  'Pago de Créditos, Servicios y/o Productos',
  'Diversos'
];
const typeOfClient = [
  'Persona Física de nacionalidad mexicana',
  'Persona Física de nacionalidad extranjera',
  'Persona Moral Mexicana'
];

export default [
  monthlyAmount,
  monthlyOperations,
  resourcesOrigin,
  resourcesDestination,
  typeOfClient
];
